<div class="arcangel-settings-container">
   <h4>Security &amp; Password</h4> 
  <div class="arcangel-settings-grid mb-2">
    <div class="arcangel-settings-label-group">
      <div class="arcangel-settings-label">Password</div>
      <div class="arcangel-settings-value">********</div>
    </div>
    <button type="button" class="btn btn-primary" (click)="changeMyPassword()">Change Password</button>

    <div class="arcangel-settings-label-group">
      <div class="arcangel-settings-label">Pin</div>
      <div class="arcangel-settings-value">****</div>
    </div>
    <button type="button" class="btn btn-primary" (click)="changeMyPin()">Change PIN</button>

    <div class="arcangel-settings-forgot">Forgot your PIN ?</div>
    <button type="button" class="btn btn-primary" (click)="forgotMyPin()">Forgot PIN</button>
  </div>
</div>